import clsx from 'clsx';
import { ScrollArea } from 'components/ui/scroll-area';
import type { ComponentProps } from 'react';
import Chat from './Chat/Chat';
import ScoreInterviewTopBar from './ScoreInterviewActionBar';
import ScoreInterviewHeader from './ScoreInterviewHeader';
import ScoreTable from './ScoreTable';

type ScoreInterviewContainerProps = ComponentProps<'div'>;

const ScoreInterview = ({ ...props }: ScoreInterviewContainerProps) => {
  return (
    <div {...props} className="">
      <ScoreInterviewHeader />
      <div className={clsx('flex flex-row justify-between gap-0')}>
        <ScrollArea type="auto" className={clsx('bg-white', `max-h-[calc(100vh-64px)]`, 'w-[50%]')}>
          <Chat />
        </ScrollArea>

        <ScrollArea type="auto" className={clsx('bg-white', `max-h-[calc(100vh-64px)]`, 'w-[40%]')}>
          <ScoreTable />
        </ScrollArea>

        <div
          className={clsx(
            // 'bg-black',
            `max-h-[calc(100vh-64px)]`,
            'overflow-auto',
            'w-[10%]',
          )}
        >
          <ScoreInterviewTopBar />
        </div>
      </div>
    </div>
  );
};

export default ScoreInterview;
